export var DataFormat;
(function (DataFormat) {
    DataFormat["JSON"] = "json";
    DataFormat["CSV"] = "csv";
    DataFormat["XLSX"] = "xlsx";
})(DataFormat || (DataFormat = {}));
